"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopularTldsWithTags = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TrendingTags = require("./TrendingTags");
var _reactMintl = require("@godaddy/react-mintl");
var _ErrorBoundary = require("./ErrorBoundary");
var _world = _interopRequireDefault(require("@ux/icon/world"));
const PopularTldsWithTags = ({
  totalItems = 3,
  tlds,
  icon = /*#__PURE__*/_react.default.createElement(_world.default, {
    height: "1.25em",
    width: "1.25em"
  }),
  logger = () => {}
}) => {
  const popularDomainEndings = tlds ? Object.keys(tlds) : [];
  const numPopularEndingsShown = Math.min(totalItems, popularDomainEndings.length);
  if (popularDomainEndings.length > 0) {
    const flyOutEndingsItem = ending => {
      return /*#__PURE__*/_react.default.createElement(_ErrorBoundary.ErrorBoundary, {
        fallback: null,
        key: ending,
        logErrorFunc: logger?.()
      }, /*#__PURE__*/_react.default.createElement("tr", {
        "data-testid": "tldItem",
        value: ending,
        key: ending
      }, /*#__PURE__*/_react.default.createElement("td", {
        "data-testid": "iconForTld",
        className: "ms1 text-gray pl-3 pr-2 pb-3"
      }, icon), /*#__PURE__*/_react.default.createElement("td", {
        "data-testid": "tldEnding",
        className: "ms1 text-gray font-weight-bold pr-3 pb-3"
      }, ending), tlds[ending] && /*#__PURE__*/_react.default.createElement("td", {
        className: "pb-3"
      }, /*#__PURE__*/_react.default.createElement(_TrendingTags.TrendingTags, {
        tags: tlds[ending]
      }))));
    };
    const popularEndings = popularDomainEndings.slice(0, numPopularEndingsShown).map(ending => flyOutEndingsItem(ending));
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "m-3"
    }, /*#__PURE__*/_react.default.createElement("p", {
      role: "heading",
      "aria-level": 3,
      className: "text-black font-weight-bold ms1 mt-3 ml-3"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "popularDomainEndings.title"
    })), /*#__PURE__*/_react.default.createElement("table", {
      className: "bg-gray p-4"
    }, /*#__PURE__*/_react.default.createElement("tbody", null, popularEndings)));
  }
  return null;
};
exports.PopularTldsWithTags = PopularTldsWithTags;
PopularTldsWithTags.propTypes = {
  icon: _propTypes.default.func,
  totalItems: _propTypes.default.number,
  tlds: _propTypes.default.shape({
    ending: _propTypes.default.arrayOf({
      color: _propTypes.default.string,
      text: _propTypes.default.string,
      textValues: _propTypes.default.object
    })
  }),
  logger: _propTypes.default.func
};